import { PricingBasis } from "../types";

export const isMonthPricing = (pricingBasis: PricingBasis | undefined) =>
  pricingBasis === "MONTH";
